(function () {
  if (window.__arkaHome) return;
  window.__arkaHome = true;
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-arka-dir]');
    if (!button) return;
    var track = button.parentNode.querySelector('.arka-track');
    if (track) track.scrollBy({ left: Number(button.getAttribute('data-arka-dir')) * track.clientWidth * 0.9, behavior: 'smooth' });
  });
  // Balance homepage rows: designs not yet shown higher on the page come first,
  // then the least-shown repeats fill the row; no design appears more than twice.
  var MAX_REPEAT = 2;
  function balance() {
    var count = {};
    document.querySelectorAll('.arka-track[data-arka-limit]').forEach(function (track) {
      var limit = Number(track.getAttribute('data-arka-limit')) || 12;
      var cards = Array.prototype.slice.call(track.querySelectorAll('.arka-card[data-arka-id]'));
      var inRow = {}, fresh = [], repeats = [];
      cards.forEach(function (card, i) {
        var id = card.getAttribute('data-arka-id');
        var n = count[id] || 0;
        if (inRow[id] || n >= MAX_REPEAT) return;
        inRow[id] = true;
        (n === 0 ? fresh : repeats).push({ card: card, n: n, i: i });
      });
      repeats.sort(function (a, b) { return a.n - b.n || a.i - b.i; });
      var keep = fresh.concat(repeats).slice(0, limit);
      cards.forEach(function (card) { card.parentNode.removeChild(card); });
      keep.forEach(function (k) {
        var id = k.card.getAttribute('data-arka-id');
        count[id] = (count[id] || 0) + 1;
        k.card.hidden = false;
        track.appendChild(k.card);
      });
      track.scrollLeft = 0;
      var sec = track.closest('.arka-sec');
      if (sec) sec.style.display = keep.length ? '' : 'none';
    });
  }
  function sync() {
    document.querySelectorAll('.arka-rail').forEach(function (rail) {
      var track = rail.querySelector('.arka-track');
      if (track) rail.classList.toggle('arka-rail--static', track.scrollWidth <= track.clientWidth + 2);
    });
  }
  function init() { balance(); sync(); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('load', sync);
  window.addEventListener('resize', sync);
})();
